import React from "react";

import Typography from "../../../../../../../../../components/Text";
import TruncatedText from "../../../../../../../../../components/Text/TruncatedText";

import useStore from "../../../../../store";
import { ChartType } from "../../../../../store/enums";

import useChartOptions from "../../ChartHooks/UseChartOptions/useChartOptions";
import css from "../Layout.module.scss";

const useVisualizationHeader = (viewingCount = 0, totalCount = 0, headerWidth = 0) => {
	const selectedChart = useStore((state) => state.selectedChart);
	const { visualizeOption, anyAxisOptions, dataSeriesOptions } = useChartOptions(selectedChart);

	const dataSeriesLabel =
		dataSeriesOptions.find((option) => option.value === visualizeOption?.dataSeries?.column)?.label || "";
	const xAxisLabel = anyAxisOptions.find((option) => option.value === visualizeOption?.xAxis?.column)?.label || "";
	const yAxisLabel = anyAxisOptions.find((option) => option.value === visualizeOption?.yAxis?.column)?.label || "";
	const allowedLabelMaxWidth = headerWidth * 0.7;
	const description = `This chart is displaying ${viewingCount} of ${totalCount} ${dataSeriesLabel} Items.`;
	let TitleComponent;

	switch (selectedChart) {
		case ChartType.NineBox:
			TitleComponent = (
				<>
					<Typography className={css.labelContainer} size="paragraph-1" weight="semi-bold" color="primary-9">
						<TruncatedText
							text={xAxisLabel}
							size="paragraph-1"
							weight="semi-bold"
							maxWidth={allowedLabelMaxWidth * 0.3}
						/>
						&nbsp;and&nbsp;
						<TruncatedText
							text={yAxisLabel}
							size="paragraph-1"
							weight="semi-bold"
							maxWidth={allowedLabelMaxWidth * 0.3}
						/>
						&nbsp;by&nbsp;
						<TruncatedText
							text={dataSeriesLabel}
							size="paragraph-1"
							weight="semi-bold"
							maxWidth={allowedLabelMaxWidth * 0.3}
						/>
					</Typography>
				</>
			);
			break;
		case ChartType.ScatterChart:
			TitleComponent = (
				<Typography className={css.labelContainer} size="paragraph-1" weight="semi-bold" color="primary-9">
					<TruncatedText
						text={xAxisLabel}
						size="paragraph-1"
						weight="semi-bold"
						maxWidth={allowedLabelMaxWidth * 0.3}
					/>
					&nbsp;and&nbsp;
					<TruncatedText
						text={yAxisLabel}
						size="paragraph-1"
						weight="semi-bold"
						maxWidth={allowedLabelMaxWidth * 0.3}
					/>
					&nbsp;by&nbsp;
					<TruncatedText
						text={dataSeriesLabel}
						size="paragraph-1"
						weight="semi-bold"
						maxWidth={allowedLabelMaxWidth * 0.3}
					/>
				</Typography>
			);
			break;
		case ChartType.TrendlineChart:
		case ChartType.ColumnChart:
			TitleComponent = (
				<Typography className={css.labelContainer} size="paragraph-1" weight="semi-bold" color="primary-9">
					<TruncatedText
						text={yAxisLabel}
						size="paragraph-1"
						weight="semi-bold"
						maxWidth={allowedLabelMaxWidth * 0.5}
					/>
					&nbsp;by&nbsp;
					<TruncatedText
						text={dataSeriesLabel}
						size="paragraph-1"
						weight="semi-bold"
						maxWidth={allowedLabelMaxWidth * 0.5}
					/>
				</Typography>
			);
			break;
		case ChartType.BarChart:
			TitleComponent = (
				<Typography className={css.labelContainer} size="paragraph-1" weight="semi-bold" color="primary-9">
					<TruncatedText
						text={xAxisLabel}
						size="paragraph-1"
						weight="semi-bold"
						maxWidth={allowedLabelMaxWidth * 0.5}
					/>
					&nbsp;by&nbsp;
					<TruncatedText
						text={dataSeriesLabel}
						size="paragraph-1"
						weight="semi-bold"
						maxWidth={allowedLabelMaxWidth * 0.5}
					/>
				</Typography>
			);
			break;
		case ChartType.HistogramChart:
			TitleComponent = (
				<Typography className={css.labelContainer} size="paragraph-1" weight="semi-bold" color="primary-9">
					<TruncatedText
						text={"Distribution of " + dataSeriesLabel}
						size="paragraph-1"
						weight="semi-bold"
						maxWidth={allowedLabelMaxWidth * 0.5}
					/>
					&nbsp;by&nbsp;
					<TruncatedText
						text={xAxisLabel}
						size="paragraph-1"
						weight="semi-bold"
						maxWidth={allowedLabelMaxWidth * 0.5}
					/>
				</Typography>
			);
			break;
	}

	return {
		description,
		TitleComponent,
	};
};

export { useVisualizationHeader };
